/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PdfUrlDto } from '../../models/pdf-url-dto';

export interface PdfControllerGeneratePdfUrl$Params {
  url: string;
}

export function pdfControllerGeneratePdfUrl(http: HttpClient, rootUrl: string, params: PdfControllerGeneratePdfUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<PdfUrlDto>> {
  const rb = new RequestBuilder(rootUrl, pdfControllerGeneratePdfUrl.PATH, 'get');
  if (params) {
    rb.query('url', params.url, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PdfUrlDto>;
    })
  );
}

pdfControllerGeneratePdfUrl.PATH = '/api/pdf/generate-url';
